import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Iec } from 'model/modal-cms/iec';
import { CMSService } from '../../../services/cms-service';
import { IecDetail } from 'model/modal-cms/iec_detail';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-detail-iec',
  templateUrl: './detail-iec.component.html',
  styleUrls: ['./detail-iec.component.scss']
})
export class DetailIecComponent implements OnInit {

  mode: number = 1;
  mode_corona: number = 1;
  id: any;

  pdfSrc: string = "assets/file/iec/IEC Coronavirus.pdf";
  pdfSrc2: string = "assets/file/iec/IEC TOSIDRA.pdf";
  pdfSrc3: string = "assets/file/iec/gyneco.pdf";

 

  urlfileIec : string = "assets/file/iec";
  

   urlfileIec_ = environment.urlfileIec;
   urlVideoIec= environment.urlVideoIec;




  iec: Iec = new Iec(null);
  iecDetail: IecDetail = new IecDetail(null)
  source_video: Iec;
  etat_iec: any;
  constructor(public activatedRoute: ActivatedRoute, private router: Router, public cmsService: CMSService) {
    this.id = activatedRoute.snapshot.params['id'];
    this.etat_iec = activatedRoute.snapshot.params['id2'];
  }
  ngOnInit() {
    this.getInfoIEC2(this.id);
    this.getInfoIECDetail3();
    if(this.id == 1){
      this.mode_corona =1;
      this.mode = 2;
    }else {
      this.mode_corona =2;   
    }
  

  }

  corona(id_c: any) {
    if (id_c == 1) {
      this.mode = 2;
      this.getInfoIEC();
    } else if (id_c == 2) {
      this.mode = 2;
      this.getInfoIECDetail();
    } else if (id_c == 3) {
      this.mode = 2;
      this.getInfoIECDetail2();
    } else if (id_c == 4) {
      this.mode = 2;
      this.getInfoIECDetail3();
    }
  }


  getInfoIEC2(id_iec:number) {
    this.cmsService.getInfoIEC(id_iec)
      .subscribe(data => {
        console.log("this.etat_iec " +this.etat_iec);
        this.iec = data
        console.log("  this.iec " +  this.iec);
        if(this.etat_iec=="V"){
          this.mode =3;
          this.source_video = this.iec.fichier_iec
        }else  if(this.etat_iec=="FA"){
          this.mode =1;
          this.source_video = this.iec.fichier_iec
        }
      },
        err => {
          console.log(err);
        })
  }

  getInfoIEC() {
    this.cmsService.getInfoIECDetail(this.id,"C1")
      .subscribe(data => {
        this.iecDetail = data
      },
        err => {
          console.log(err);
        })
  }



  getInfoIECDetail() {
    this.cmsService.getInfoIECDetail(this.id, "C2")
      .subscribe(data => {
        this.iecDetail = data
      },
        err => {
          console.log(err);
        })
  }

  getInfoIECDetail2() {
    this.cmsService.getInfoIECDetail(this.id, "C3")
      .subscribe(data => {
        this.iecDetail = data
      },
        err => {
          console.log(err);
        })
  }


  getInfoIECDetail3() {
    this.cmsService.getInfoIECDetail(this.id, "C4")
      .subscribe(data => {
        this.iecDetail = data
      },
        err => {
          console.log(err);
        })
  }

  return() {
    this.router.navigate(['iec']);
  }

 



}
